<template>
  <footer>
    <cookie-law>
      <div slot-scope="props">
        {{ $t("cookiesPolicy:cookies.text") }}
        <router-link to="cookies">{{
          $t("cookiesPolicy:cookies.text_href")
        }}</router-link>
        <a
          data-test="cookies-button-accept"
          class="btn mb-3 ml-5 btn-primary btn-md"
          @click="props.accept"
          ><span>{{ $t("cookiesPolicy:cookies.buttons.accept") }}</span></a
        >
      </div>
    </cookie-law>
  </footer>
</template>

<script>
import CookieLaw from "vue-cookie-law";
export default {
  name: "dashboard-footer",
  components: { CookieLaw }
};
</script>
